/**
 * Decorative halftone dot field that fills the right edge of the sign-in page.
 * Dot radius grows towards a focal point on the right; a soft void is punched
 * out of the middle so the field reads as a sphere rather than a flat grid.
 */

const COLS = 21;
const ROWS = 31;
const STEP = 26;
const W = COLS * STEP;
const H = ROWS * STEP;

const FOCUS_X = W * 0.82;
const FOCUS_Y = H * 0.5;
const SPREAD = W * 1.05;
const VOID_R = W * 0.3;

function radius(cx: number, cy: number) {
  const dx = (cx - FOCUS_X) / SPREAD;
  const dy = (cy - FOCUS_Y) / (SPREAD * 1.15);
  const d = Math.sqrt(dx * dx + dy * dy);

  // Falls off sharply with distance from the focus…
  let r = (1 - Math.min(1, d)) ** 2.2 * (STEP * 0.52);

  // …and thins out again inside the soft void at the centre of the field.
  const voidD = Math.sqrt((cx - FOCUS_X) ** 2 + ((cy - FOCUS_Y) * 0.9) ** 2);
  if (voidD < VOID_R) r *= 0.2 + 0.8 * (voidD / VOID_R) ** 1.6;

  return r;
}

const DOTS: { cx: number; cy: number; r: number }[] = [];
for (let row = 0; row < ROWS; row++) {
  for (let col = 0; col < COLS; col++) {
    const cx = col * STEP + (row % 2 ? STEP / 2 : 0) + STEP / 2;
    const cy = row * STEP + STEP / 2;
    const r = radius(cx, cy);
    if (r > 0.45) DOTS.push({ cx, cy, r: Number(r.toFixed(2)) });
  }
}

export function HalftonePanel() {
  return (
    <svg
      className="halftone"
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="xMaxYMid slice"
      aria-hidden="true"
      focusable="false"
    >
      <g fill="var(--brand)">
        {DOTS.map((d, i) => (
          <circle key={i} cx={d.cx} cy={d.cy} r={d.r} />
        ))}
      </g>
    </svg>
  );
}
